import React from 'react';

const PremiumGate = ({ children }) => {
  return <>{children}</>;
};

export { PremiumGate };
export default PremiumGate;
